export default {
  knowListData: state => state.knowListData,
  knowTreeData: state => state.knowTreeData,
  detail: state => state.detail,
  knowTeam: state => state.knowTeam,
};
